<template>
    <div id="einsatz">
        <button @click="$router.push('/hydranten/'+this.routeParams)">
            <img src="@/assets/Icons/Hydrant.svg">
        </button>
        <button @click="$router.push('/gefahrgut/'+this.routeParams)">
            <img src="@/assets/Icons/Gefahrgut.svg">
        </button>
        <button @click="$router.push('/hilfeimwald/'+this.routeParams)">
            <img src="@/assets/Icons/HilfeImWald.svg">
        </button>
        <button @click="$router.push('/what3words/'+this.routeParams)">
            <img class="w3w" src="@/assets/Icons/what3words.png">
        </button>
        <button @click="$router.push('/sammelpunkte/'+this.routeParams)">
            <img src="@/assets/Icons/Sammelpunkte.svg">
        </button>
        <button @click="$router.push('/funk/' + this.routeParams)">
            <img src="@/assets/Icons/Funk.svg">
        </button>
        <button @click="$router.push('/eurorescue/' + this.routeParams)">
            <img src="@/assets/Icons/Eurorescue.png">
        </button>
        <!--<button>
            <img src="@/assets/Icons/Brandmeldeanlage.svg">
        </button>-->
        <!--<button @click="$router.push('/wea-nis/'+this.routeParams)">
            <img src="@/assets/Icons/WEA-NIS.png">
        </button>-->
    </div>
    <FooterNavigation :view="'home'"/>
</template>
  
<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterNavigation from '@/components/Home/FooterNavigation.vue';

export default {
    name: 'EinsatzView',
    components: {
        Header,
        Footer,
        FooterNavigation
    },
    data() {
        return{
            routeParams:String,
        }
    },
    methods:{
    },
    created(){
        this.routeParams = this.$route.params.id;
    }
}
</script>

<style lang="scss">
#einsatz{
    margin-top: 5.5rem;
    margin-bottom: 4.5rem;

    button{
        width: 41%;
        max-width: 17rem;
        margin: 0.3rem;
        background-color: white;
        border: solid black 3px;
        border-radius: 13px;

        img{
            width: 100%;
            padding: 0.1rem;
        }
    }
}
</style>
  